
// import axios from 'axios';
// import AWS from "aws-sdk";


// class Uploader {


//   constructor() {
//     AWS.config.update({
//       region: "ap-southeast-1",
//       credentials: {
//         accessKeyId: "",
//         secretAccessKey: "",
//         s3Url: "https://zape02.s3.ap-southeast-1.amazonaws.com",
//         visibility: "public",
//       }
//     });
 
//     this.s3 = new AWS.S3();

//   }
  

//   uploadImage(payload) {
//     let s3 = this.s3;
//     return new Promise(function (resolve, reject) {
//       let encodedImage = payload.file;
 
// console.log("let decodedImage = encodedImage",encodedImage);

//       var filePath = payload.fileName;
//       let contentType = '';
//       const ext = payload.fileName.split('.').pop().toLowerCase();

//       if (ext === 'm3u8') {
//         contentType = 'application/vnd.apple.mpegurl';
//       } else if (ext === 'ts') {
//         contentType = 'video/MP2T';
//       } else if (ext === 'mp4') {
//         contentType = 'video/mp4';
//       } else {
//         contentType = payload.contentType || 'application/octet-stream';
//       }

//       var params = {
//         "Body": encodedImage,
//         "Bucket": "zape02",
//         "Key": filePath,
//         "ACL": "public-read",
//         "ContentType": contentType 
//       };
//       s3.upload(params, function (err, data) {
//         if (err) {
//           reject(err);
//         } else {
//           console.log('data', data);
      
//           resolve(data);
//         }
//       });
//     })
//   }

// }

// export default Uploader;


// awsImageUpload.js
import axios from 'axios';

class Uploader {
  constructor() {
    this.baseURL = process.env.VUE_APP_API_URL;

    this.api = axios.create({
      baseURL: this.baseURL,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('_t')}`,
        'Content-Type': 'application/json'
      }
    });

    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('_t');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    
    this.api.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;
 
        if (error.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          
          try {
         
            const refreshToken = localStorage.getItem('_refresh_token');
            if (refreshToken) {
              const response = await axios.post(`${this.baseURL}/refresh`, {
                refresh_token: refreshToken
              });
              
              const { token, refresh_token } = response.data;
              localStorage.setItem('_t', token);
              localStorage.setItem('_refresh_token', refresh_token);
 
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return this.api(originalRequest);
            }
          } catch (refreshError) {
          
            console.error('Token refresh failed:', refreshError);
            this.handleLogout();
            return Promise.reject(refreshError);
          }
        }
        
        return Promise.reject(error);
      }
    );
  }
  
  handleLogout() {
   
    localStorage.removeItem('_t');
    localStorage.removeItem('_refresh_token');
 
    window.location.href = '/login';
  }

  async getPresignedUrl(fileName, contentType) {
    try {
      const ext = fileName.split('.').pop().toLowerCase();
      const response = await this.api.post('/s3/generate-presigned-url', {
        ext: ext,
        type: contentType
      });
      return response.data;
    } catch (error) {
      console.error('Error getting presigned URL:', error);
      throw error;
    }
  }

  async uploadFile(file, fileName, contentType, onProgress = null) {
    try {

      const { url: presignedUrl, key: s3Key, publicUrl } = await this.getPresignedUrl(fileName, contentType);
      
      const uploadResponse = await axios.put(presignedUrl, file, {
        headers: {
          'Content-Type': contentType,
        },
        onUploadProgress: onProgress
      });
    
      const finalUrl = publicUrl || `https://zape02.s3.ap-southeast-1.amazonaws.com/${s3Key}`;
      
      console.log('Upload successful:', finalUrl);
      
      return {
        Location: finalUrl,
        Key: s3Key,
        status: uploadResponse.status
      };
    } catch (error) {
      console.error('Upload error:', error);
      if (error.response) {
        console.error('Response error:', error.response.data);
      }
      throw error;
    }
  }

  async uploadDirect(file, options = {}) {
    const formData = new FormData();
    formData.append('file', file);
    
    if (options.type) formData.append('type', options.type);
    if (options.path) formData.append('path', options.path);
    
    const response = await this.api.post('/s3/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: options.onProgress || null
    });
    
    return response.data;
  }

  uploadImage(payload) {
    return this.uploadFile(
      payload.file,
      payload.fileName,
      payload.contentType || this.getContentType(payload.fileName),
      payload.onProgress
    );
  }

  getContentType(fileName) {
    const ext = fileName.split('.').pop().toLowerCase();
    const mimeTypes = {

      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'webp': 'image/webp',
      'svg': 'image/svg+xml',
 
      'mp4': 'video/mp4',
      'm3u8': 'application/vnd.apple.mpegurl',
      'ts': 'video/MP2T',
      'mov': 'video/quicktime',
      'avi': 'video/x-msvideo',
      'mkv': 'video/x-matroska',
      
      'pdf': 'application/pdf',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'ppt': 'application/vnd.ms-powerpoint',
      'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',

      'mp3': 'audio/mpeg',
      'wav': 'audio/wav',
      'ogg': 'audio/ogg',
    };
    
    return mimeTypes[ext] || 'application/octet-stream';
  }
}

export default Uploader;